import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class FavoritesService {
    
    private _favoritesUrl = '/favoritesData';
    private serverURL: string;
   
    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    getFavoritesSellersByUser() {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });                

        return this.http.get(this.serverURL + this._favoritesUrl + "/sellers", options).toPromise().then(res => { 
            
            if(JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }            
        
        }, this.handleError);

    }

    getFavoritesArtisansByUser() {

        var token = localStorage.getItem('token');
        var authHeader = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
        
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        
        let options = new RequestOptions({ headers: authHeader, body: "" });                

        return this.http.get(this.serverURL + this._favoritesUrl + "/artesans", options).toPromise().then(res => { 
            
            if(JSON.parse(res.text()).code == 1) {
                return JSON.parse(res.text()).rows;
            } else {
                return null;
            }            
        
        }, this.handleError);

    }

    private handleError (error:Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }        

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/favorites/favorites.service.ts
 **/